// extracted by mini-css-extract-plugin
export default {"centerDiv":"StartView_centerDiv__dv0lc","startView":"StartView_startView__gAI9U"};